import $api from "../http"
export default class RoomService {
    static getTimeTour(){
        return $api.get("/getTimeDeference")
    }
    static getInfRoom(name){
        return $api.post("/getInfRoom" , {name})
    }
    static check_status_game(){
        return $api.get("/check_status_game")
    }
    static getRooms_free(){
        return $api.get("/getRooms_free")
    }
    static getOnline(){
        return $api.get("/getOnline")
    }
    static getRoomData(name,choice){
        return $api.post("/room_data" , {name,choice})
    }
    static getRoom_listCost(page , sort){
        return $api.get("/cost_rooms_list" , {params:{page,sort}})

    }
    static checkTourReg(){
        return $api.post("/checkTourReg")
    }
    static go_tour(){
        return $api.post("/go_tour")
    }
    static enter_tour(){
        return $api.post("/enter_tour")
    }
    static findRoomFreeData(name){
        return $api.post("/find_free_room" , {name})
    }
    static getRoom_byName(name){
        return $api.get("/search_room" , {params: {name}})
    }
    static getLengthRoom(){
        return $api.get("/getLengthRoom")
    }
}